import React from 'react'

function Footer() {
  return <footer>
    <div>
    <h1>INSTAC</h1>
    <p>
        @all right reserved
    </p>
    </div>
    <div>
        <h5>Follow Us</h5>
        <div>
            <a href='https://github.com/RamThakur10007'>Github</a>
            <a href='https://instagram.com/ram_thakur_11?utm_source=qr&igshid=MzNlNGNkZWQ4Mg%3D%3D'>Instagram</a>
            <a href='https://twitter.com/ThakurR93539886?t=qSUWRTVUNcAdKoTdjChixQ&s=09'>Twitter</a>
        </div>
    </div>
  </footer>
}

export default Footer
